import React, { useState } from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { IconButton, InputAdornment } from '@material-ui/core';
import { Clear } from '@material-ui/icons';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import moment from 'moment';

import styles from './TableDatePicker.module.css';

import calendar from 'assets/img/calendar.png';

interface ITableDatePicker {
  name: string;
  label: string;
  format?: string;
  disabled?: boolean;
  views?: ('date' | 'year' | 'month')[];
  onChange: (name: string, value?: string | null | undefined) => void;
  onClickClear: (name: string) => void;
}

const TableDatePicker = ({
  name, label, format = 'DD-MM-YYYY', views = ['date'], disabled, onChange, onClickClear }: ITableDatePicker) => {
  const [selectedDate, setSelectedDate] = useState<MaterialUiPickersDate>(null);

  const handleDateChange = (date: MaterialUiPickersDate, _?: string | null | undefined) => {
    setSelectedDate(date);
    onChange(name, moment(date).format('DD-MM-YYYY'));
  };

  const handleClearDate = () => {
    setSelectedDate(null);
    onClickClear(name);
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        inputVariant="filled"
        variant="inline"
        autoOk
        name={name}
        label={label}
        format={format}
        views={views}
        disabled={disabled}
        value={selectedDate}
        fullWidth
        className={styles.input}
        onChange={handleDateChange}
        keyboardIcon={<img src={calendar} alt="Calendar logo" />}
        InputProps={{
          disableUnderline: true,
          startAdornment: selectedDate && (
            <InputAdornment position="start">
              <IconButton onClick={() => handleClearDate()} size="small">
                <Clear style={{ fontSize: '20px' }} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </MuiPickersUtilsProvider>
  );
};
export default TableDatePicker;
